// extracted by mini-css-extract-plugin
module.exports = {"root":"GallerySlide_root__m66L0","rotation":"GallerySlide_rotation___ZJEB"};